import { Button, Form } from "reactstrap";
import useAxios from "../../../../Utils/useAxios";
import { InputField, NumberInputField } from "../../../../CommonElements";
import createUnitKerja from "../services/createUnitKerja";
import updateUnitKerja from "../services/updateUnitKerja";
import { Controller, useForm } from "react-hook-form";

const UnitKerjaBaruForm = ({ resetState, toggle, data }) => {
  const { control, handleSubmit } = useForm({ defaultValues: data });
  const axiosInstance = useAxios();

  const createItem = (data) => {
    createUnitKerja(axiosInstance, data).then(() => {
      resetState();
      toggle();
    });
  };

  const updateItem = (data) => {
    updateUnitKerja(axiosInstance, data.id_unit_kerja, data).then(() => {
      resetState();
      toggle();
    });
  };

  return (
    <Form onSubmit={data ? handleSubmit(updateItem) : handleSubmit(createItem)}>
      <Controller
        name="kode_unit_kerja"
        control={control}
        render={({ field, fieldState }) => (
          <InputField
            label={"Kode Unit Kerja"}
            defaultValue={data?.kode_unit_kerja}
            fieldState={fieldState}
            {...field}
          />
        )}
      />
      <Controller
        name="nama_unit_kerja"
        control={control}
        render={({ field, fieldState }) => (
          <InputField
            label={"Nama Unit Kerja"}
            defaultValue={data?.nama_unit_kerja}
            fieldState={fieldState}
            {...field}
          />
        )}
      />
      <Controller
        name="nama_kepala"
        control={control}
        render={({ field, fieldState }) => (
          <InputField
            label={"Nama Kepala"}
            defaultValue={data?.nama_kepala}
            fieldState={fieldState}
            {...field}
          />
        )}
      />
      <Controller
        name="nama_jabatan"
        control={control}
        render={({ field, fieldState }) => (
          <InputField
            label={"Nama Jabatan"}
            defaultValue={data?.nama_jabatan}
            fieldState={fieldState}
            {...field}
          />
        )}
      />
      <Controller
        name="email_milis"
        control={control}
        render={({ field, fieldState }) => (
          <InputField
            label={"Email"}
            defaultValue={data?.email_milis}
            fieldState={fieldState}
            {...field}
          />
        )}
      />
      <Controller
        name="nama_unit_kerja_lokal"
        control={control}
        render={({ field, fieldState }) => (
          <InputField
            label={"Nama Unit Kerja Lokal"}
            defaultValue={data?.nama_unit_kerja_lokal}
            fieldState={fieldState}
            {...field}
          />
        )}
      />
      <Controller
        name="email_pic"
        control={control}
        render={({ field, fieldState }) => (
          <InputField
            label={"Nama Unit Email PIC"}
            defaultValue={data?.email_pic}
            fieldState={fieldState}
            {...field}
          />
        )}
      />
      <Controller
        name="show"
        control={control}
        rules={{ required: "Masukkan nilai show" }}
        render={({ field, fieldState }) => (
          <NumberInputField
            label={"Show"}
            defaultValue={data?.email_pic}
            fieldState={fieldState}
            {...field}
            isReqired
          />
        )}
      />
      <Controller
        name="kode_baru"
        control={control}
        render={({ field, fieldState }) => (
          <InputField
            label={"Kode Unit Kerja Baru"}
            defaultValue={data?.kode_baru}
            fieldState={fieldState}
            {...field}
          />
        )}
      />
      <Button color="primary">Simpan</Button>
    </Form>
  );
};

export default UnitKerjaBaruForm;
